import * as actions from "../actions/"
import {toast} from "react-toastify"

const defaultState = {
    fetching:false
}

export default function reducer(state=defaultState, action) {

    switch (action.type) {
        case actions.FETCH_STATUS.PENDING: {
            return {...state, fetching: true}
        }
        case actions.FETCH_STATUS.ERROR: {
            toast.error(action.payload.response.data.message);
            return {...state, error: action.payload, fetching: false}
        }
        case actions.FETCH_STATUS.UPDATE: {
            return {
                ...state,
                ...action.payload,
            }
        }
        case actions.FETCH_STATUS.SUCCESS: {
            return {
              ...state,
              fetching: false
            }
        }
    }

    return state
}


// WEBPACK FOOTER //
// ./src/reducers/statusReducer.js